var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConvenientManagement = function SvgConvenientManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#convenient-management_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.319,
    d: "M35.484 22.849c15.61-2.419 24.184 7.275 10.993 14.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m47.273 34.047 2.041 4.124a.22.22 0 0 1-.238.313l-3.671-.702a.22.22 0 0 1-.157-.31l1.629-3.422a.22.22 0 0 1 .395-.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#convenient-management_svg__b)",
    fillOpacity: 0.4,
    d: "m47.273 34.047 2.041 4.124a.22.22 0 0 1-.238.313l-3.671-.702a.22.22 0 0 1-.157-.31l1.629-3.422a.22.22 0 0 1 .395-.003"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.319,
    d: "M23.501 31.99C7.891 34.41-.683 24.716 12.508 17.68"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.712 20.792 9.67 16.668a.22.22 0 0 1 .239-.313l3.67.703a.22.22 0 0 1 .158.31l-1.63 3.421a.22.22 0 0 1-.395.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#convenient-management_svg__c)",
    fillOpacity: 0.4,
    d: "M11.712 20.792 9.67 16.668a.22.22 0 0 1 .239-.313l3.67.703a.22.22 0 0 1 .158.31l-1.63 3.421a.22.22 0 0 1-.395.003"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.172 23.83c0-.13-.03-.26-.086-.378l-5.283-11.068a.88.88 0 0 1 .347-1.137l2.01-1.182a4.4 4.4 0 0 1 2.23-.607h17.29a3.08 3.08 0 0 1 3.078 3.059l.19 31.264a3.96 3.96 0 0 1-1.287 2.945l-1.239 1.132a.88.88 0 0 1-.75.217l-15.778-2.87a.88.88 0 0 1-.722-.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#convenient-management_svg__d)",
    d: "M23.172 23.83c0-.13-.03-.26-.086-.378l-5.283-11.068a.88.88 0 0 1 .347-1.137l2.01-1.182a4.4 4.4 0 0 1 2.23-.607h17.29a3.08 3.08 0 0 1 3.078 3.059l.19 31.264a3.96 3.96 0 0 1-1.287 2.945l-1.239 1.132a.88.88 0 0 1-.75.217l-15.778-2.87a.88.88 0 0 1-.722-.864z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.66,
    d: "M19.654 11.107h18.907a2.31 2.31 0 0 1 2.309 2.308v32.54a2.31 2.31 0 0 1-2.309 2.307H19.654a2.31 2.31 0 0 1-2.308-2.308V13.415a2.31 2.31 0 0 1 2.308-2.308Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    d: "M11.739 27.217a.88.88 0 0 1 .312-.672l7.695-6.495a.88.88 0 0 1 1.135 0l7.695 6.495a.88.88 0 0 1 .312.672V37.6a.88.88 0 0 1-.88.88h-15.39a.88.88 0 0 1-.88-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#convenient-management_svg__e)",
    fillOpacity: 0.6,
    d: "M11.739 27.217a.88.88 0 0 1 .312-.672l7.695-6.495a.88.88 0 0 1 1.135 0l7.695 6.495a.88.88 0 0 1 .312.672V37.6a.88.88 0 0 1-.88.88h-15.39a.88.88 0 0 1-.88-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#895FFC",
    d: "M31.306 27.486a.88.88 0 0 1 .88-.88h8.354V38.48h-8.354a.88.88 0 0 1-.88-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#convenient-management_svg__f)",
    fillOpacity: 0.8,
    d: "M31.306 27.486a.88.88 0 0 1 .88-.88h8.354V38.48h-8.354a.88.88 0 0 1-.88-.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.857 29.684a.44.44 0 0 1 .44-.44h2.199v2.639h-2.199a.44.44 0 0 1-.44-.44zM33.285 29.684a.44.44 0 0 1 .44-.44h1.759a.44.44 0 0 1 .44.44v1.76a.44.44 0 0 1-.44.439h-1.76a.44.44 0 0 1-.439-.44z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 1.446,
    d: "m16.576 30.535 2.475 2.892 4.756-5.062"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.078,
    height: 3.078,
    x: 27.569,
    y: 42.436,
    fill: "#000",
    rx: 1.539
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.475,
    height: 1.759,
    x: 25.37,
    y: 13.854,
    fill: "#000",
    rx: 0.879
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "convenient-management_svg__b",
    x1: 47.081,
    x2: 49.176,
    y1: 37.16,
    y2: 35.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "convenient-management_svg__c",
    x1: 11.904,
    x2: 9.809,
    y1: 17.68,
    y2: 18.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "convenient-management_svg__d",
    x1: 32.186,
    x2: -1.27,
    y1: 15.614,
    y2: 10.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "convenient-management_svg__e",
    x1: 20.313,
    x2: 20.313,
    y1: 19.571,
    y2: 38.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "convenient-management_svg__f",
    x1: 35.923,
    x2: 35.923,
    y1: 26.606,
    y2: 38.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E90F9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E90F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "convenient-management_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
export default SvgConvenientManagement;